import {Component, EventEmitter, inject, OnInit, Output, signal, WritableSignal, ChangeDetectionStrategy} from '@angular/core';
import {PlaceLeaderboard} from '@/app/core/models/p-place/pixel';
import {PlaceLeaderboardService} from '@services/p-place/place-leaderboard.service';
import {TranslatePipe} from '@ngx-translate/core';
import {animate, style, transition, trigger} from '@angular/animations';
import {PageSelectorComponent} from '@/app/shared';
import {NgClass} from '@angular/common';
import {AuthService} from '@services/auth.service';

@Component({
	selector: 'peps-place-leaderboard',
	imports: [
		TranslatePipe,
		PageSelectorComponent,
		NgClass
	],
	templateUrl: './leaderboard.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	animations: [
		trigger('fadeInOut', [
			transition(':enter', [
				style({ opacity: 0 }),
				animate('300ms ease-out', style({ opacity: 1 }))
			]),
			transition(':leave', [
				animate('300ms ease-in', style({ opacity: 0 }))
			])
		]),
		trigger('scaleInOut', [
			transition(':enter', [
				style({ transform: 'scale(0.8)' }),
				animate('300ms ease-out', style({ transform: 'scale(1)' }))
			]),
			transition(':leave', [
				animate('300ms ease-in', style({ transform: 'scale(0.8)' }))
			])
		])
	]
})
export class LeaderboardComponent implements OnInit {

	private readonly placeLeaderboardService = inject(PlaceLeaderboardService);
	private readonly authService = inject(AuthService);

	protected leaderboard: WritableSignal<PlaceLeaderboard[]> = signal([]);
	protected totalPage: WritableSignal<number> = signal(0);
	protected currentPage: WritableSignal<number> = signal(0);
	currentUsername: string | null = null;

	@Output() close = new EventEmitter<void>();

	ngOnInit() {
		this.loadLeaderboard();
		if (this.authService.isAuthenticated()) {
			this.currentUsername = this.authService.getUser()!.username
		}
	}

	private loadLeaderboard() {
		this.placeLeaderboardService.getLeaderboard(this.currentPage()).subscribe({
			next: data => {
				this.leaderboard.set(data.content);
				this.totalPage.set(data.totalPages);
			}
		})
	}

	protected closeLeaderboardModal() {
		this.close.emit();
	}

	protected onBackgroundClick(event: Event) {
		if (event.target === event.currentTarget) {
			this.closeLeaderboardModal();
		}
	}

	protected onPageChange(newPage: number) {
		this.currentPage.set(newPage);
		this.loadLeaderboard();
	}

	protected getGlobalRank(index: number): number {
		return (this.currentPage() - 1) * 20 + index + 1;
	}
}
